import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "text-muted mt-1 font-size-small lh-primary" }

import {LogInterface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/log/Interface";
import DataProviderLogLine
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/log/DataProviderLogLine.vue";
import {computed, ref} from "vue";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import {localeDateTimeString} from "~/core-ui/ts/CoreUiHelpersMixin";
import Dictionary from "~/ts/library/Dictionary";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DataProviderLogCard"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    log: {}
  },
  setup(__props: any) {

let props = __props;

let showAll = ref(false);

let linesToDisplay = computed(() => {
    let result = props.log.lines;
    if (!showAll.value) {
        result = [result[0]];
    }
    return result;
});
let relationsGrouppedByType = computed<Dictionary<string[]>>(() => {
    let result: Dictionary<string[]> = {};
    for (let item of props.log.relations) {
        if (!result.hasOwnProperty(item.entityTypeDescr)) {
            result[item.entityTypeDescr] = [];
        }
        result[item.entityTypeDescr].push(item.entityId);
    }
    return result;
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createVNode(ElCardHeader, { "button-col-span": 12 }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.log.entityTypeDescr) + " ", 1),
          _createElementVNode("div", _hoisted_1, [
            (__props.log.repeatDateTimes.length < 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(localeDateTimeString)(__props.log.dateTime, true)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Действие повторялось " + _toDisplayString(__props.log.repeatDateTimes.length) + " раз с одинаковым исходом в период с " + _toDisplayString(_unref(localeDateTimeString)(__props.log.repeatDateTimes[0], true)) + " по " + _toDisplayString(_unref(localeDateTimeString)(__props.log.repeatDateTimes[__props.log.repeatDateTimes.length - 1], true)), 1)
                ], 64))
          ])
        ]),
        default: _withCtx(() => [
          (__props.log.lines.length > 1)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                plain: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showAll) //@ts-ignore
 ? showAll.value = !_unref(showAll) : showAll = !_unref(showAll)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(showAll) ? 'Свернуть' : `Показать полностью (${__props.log.lines.length})`), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (__props.log.lines.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(linesToDisplay), (line, key) => {
            return (_openBlock(), _createBlock(DataProviderLogLine, {
              key: key,
              line: line,
              "expanded-available-to-display": _unref(showAll)
            }, null, 8, ["line", "expanded-available-to-display"]))
          }), 128))
        : _createCommentVNode("", true),
      (__props.log.relations.length)
        ? (_openBlock(), _createBlock(ElCardSection, { key: 1 }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("p", null, "Сущности, сохраненные во время этого действия:", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relationsGrouppedByType), (ids, key) => {
                return (_openBlock(), _createElementBlock("p", null, _toDisplayString(key) + ": " + _toDisplayString(ids.join(", ")), 1))
              }), 256))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})